import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';

import App from "./App";
//const getBasename = (path: any) => path.substr(0, path.lastIndexOf('/'));
console.log(window.location.pathname);

// 브라우저 알림 권한 요청 (QR 전화번호 수집 등 알람용)
if ('Notification' in window && Notification.permission === 'default') {
  Notification.requestPermission().then(permission => {
    console.log('[알림 권한]', permission);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  // <BrowserRouter basename='/brd'>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);
